import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';

export type ApiGetCompaniesListRequest = {
    query: string;
    limit: number;
};

export type ApiGetCompaniesListResponse = ApiResponse<
    {
        company: string;
        kpp: string;
        inn: string;
        ogrn: string;
        registered_address: string;
    }[]
>;

export type AppGetCompaniesListResponse = ApiGetCompaniesListResponse;

export const GetCompaniesList = (body: ApiGetCompaniesListRequest): Promise<AppGetCompaniesListResponse> =>
    axiosAPI.post<ApiGetCompaniesListResponse>('/v1/dadata/company', body).then((res) => res.data);
